import type { FunctionComponent } from 'react'

import { Markdown } from '../../../../components/markdown'
import type { BentoPieceRectangleFourPartsFragment } from '../../../../graphql/queries/GetBentoOne.graphql'
import { usePersonalizations } from '../../../../lib/hooks/usePersonalizations'
import { renderTemplate } from '../../../../lib/utils/text'
import styles from './bento-rectangle-four-parts.module.scss'

export const Part: FunctionComponent<Props> = ({ copy }) => {
    const personalizations = usePersonalizations()

    return (
        <div className={styles.copy}>
            <Markdown
                typeStyle='heading-xs'
                markdown={renderTemplate(copy, personalizations)}
            />
        </div>
    )
}

export default Part

type Props = Omit<BentoPieceRectangleFourPartsFragment, 'sys' | 'type'> & {
    copy?: string
}
